import { SearchItem } from '../../core';
import { Sort, SortOrder } from '../../grid';
import { ColumnId } from '../model/column-id.model';
import { TranslationKeyMap } from '../search.i18n';

function _dataForColumn(
    column: ColumnId,
    data: SearchItem,
): { value: any; type: 'string' | 'number' } {
    switch (column) {
        case ColumnId.USER_NAME:
            return { value: data.targetUserName, type: 'string' };
        case ColumnId.EVENT_DATE:
            return {
                value: data.eventDate?.getTime() ?? Number.MIN_VALUE,
                type: 'number',
            };
        case ColumnId.EVALUATION_DATE:
            return {
                value: data.evaluationDate?.getTime() ?? Number.MIN_VALUE,
                type: 'number',
            };
        case ColumnId.SCORE:
            return { value: (data as any).percentage, type: 'number' };
        case ColumnId.EVALUATION_NAME:
            return { value: data.evaluationName, type: 'string' };
        case ColumnId.STATUS:
            return {
                value:
                    data.draftId != null
                        ? TranslationKeyMap._9476_DRAFT
                        : TranslationKeyMap._9113_PUBLISHED,
                type: 'string',
            };
        default:
            return { value: null, type: null };
    }
}

function _sortColumn(
    valA: string | number | any,
    valB: string | number | any,
    type: 'string' | 'number',
    order: SortOrder,
): number {
    if (type === 'number') {
        valA = valA == null ? Number.MIN_SAFE_INTEGER : valA;
        valB = valB == null ? Number.MIN_SAFE_INTEGER : valB;
    } else {
        valA = valA == null ? '' : valA;
        valB = valB == null ? '' : valB;
    }
    return type === 'number'
        ? order === SortOrder.ASC
            ? valA - valB
            : valB - valA
        : order === SortOrder.ASC
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
}

export function sortRows(
    rows: SearchItem[],
    nextSortOptions: Sort,
): SearchItem[] {
    const nextFilteredRows = [...rows];
    nextFilteredRows.sort((a, b) => {
        const av = _dataForColumn(nextSortOptions.columnId as ColumnId, a);
        const bv = _dataForColumn(nextSortOptions.columnId as ColumnId, b);
        let result = _sortColumn(
            av.value,
            bv.value,
            av.type,
            nextSortOptions.order,
        );
        // TODO write a recursion for this later
        if (result === 0) {
            // fallback sort by name asc
            const av3 = _dataForColumn(ColumnId.USER_NAME, a);
            const bv3 = _dataForColumn(ColumnId.USER_NAME, b);
            result = _sortColumn(av3.value, bv3.value, av3.type, SortOrder.ASC);
        }
        return result;
    });
    return nextFilteredRows;
}
